import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resetFilterHandler animateFadeUp"},[_c('p',[_vm._v(_vm._s(_vm.$t("MyWorkspaces.noCorrespondingFilterMatch")))]),_c(VBtn,{attrs:{"large":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v(_vm._s(_vm.$t("MyWorkspaces.filterButtons.resetFilter")))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }